import {useAuthContext} from '../AuthProvider'

export const useUser = () => {
  const {user} = useAuthContext()
  return user
}
